<app-job-pointe-list [tableData]="data" [tableFilters]="filters" [source]="data.type"> </app-job-pointe-list>
